import { render } from "./ClientePagoList.vue?vue&type=template&id=3c2f442a&scoped=true"
import script from "./ClientePagoList.vue?vue&type=script&lang=js"
export * from "./ClientePagoList.vue?vue&type=script&lang=js"

import "./ClientePagoList.vue?vue&type=style&index=0&id=3c2f442a&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c2f442a"]])

export default __exports__